
export default function ExampleSearchbar() {
    return (
        <div className="exampleSearchbarDiv">
            <input type='text' className="exampleSearchbar" placeholder='search products'/>
        </div>
    )
}
